import { formatValue, ONE_DECIMAL, BY_THREE, reportDate } from './utils';
import { MISSING_VALUE, NO_LIFT } from '../constants/stats';

export const MISSING_DOLLAR_VALUE = `$${MISSING_VALUE}`;

const DOUBLE_DASHES = '--';

/**
 * @deprecated
 */
export const fLift = (
  value: number | null | undefined,
  missingValueOverride: string | undefined = undefined,
  format: 'percentage' | 'times' = 'percentage'
) => {
  if (_.isNil(value)) {
    return missingValueOverride ?? MISSING_VALUE;
  }
  if (value <= 0) {
    return NO_LIFT;
  }
  if (format === 'times') {
    return formatValue(value / 100, ONE_DECIMAL, { suffix: 'x' });
  }

  return formatValue(value, ONE_DECIMAL, { suffix: '%' });
};

/**
 * @deprecated
 */
export const fVisits = (value: number | null, format = ONE_DECIMAL) => {
  if (_.isNil(value)) {
    return MISSING_VALUE;
  }
  if (value <= 0) {
    return '0';
  }
  return formatValue(value, format);
};

/**
 * @deprecated
 */
export const fVisitsUnrounded = (value: number | null) =>
  fVisits(value, BY_THREE);

/**
 * @deprecated
 */
export const fVR = (value: number) => fLift(value, undefined, 'times');

/**
 * @deprecated
 */
export const fCPV = (adSpend: number | string | null, divBy: number | null) => {
  if (_.isNil(adSpend)) {
    return MISSING_DOLLAR_VALUE;
  }
  if (_.isNil(divBy) || divBy <= 0) {
    return MISSING_DOLLAR_VALUE;
  }

  const val = Number.parseFloat(adSpend.toString().replaceAll(',', '')) / divBy;

  if (val === 0 || val === Infinity || _.isNaN(val))
    return MISSING_DOLLAR_VALUE;

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(val);
};

/**
 * @deprecated
 */
export const fFull = (value: number | null) => formatValue(value, BY_THREE);
/**
 * @deprecated
 */
export const fUUsers = (value: number | null) =>
  formatValue(value, ONE_DECIMAL);

/**
 * @deprecated
 */
export const fCurrency = (
  value: number | string | null,
  numDecimal = 1,
  overrideCutoff = false,
  options = {}
) => {
  if (value === null) return `$${DOUBLE_DASHES}`;
  // For numbers less than $1000, we want to display the full value including cents, e.g. $5.49, including the .49
  // For round numbers, like $5.00 or $0.00, we will omit the .00 and just display $5 or $0, for cleaner display
  const twoDecimalCutoff = 1000;
  const valueAsFloat = Number.parseFloat(value.toString());
  const targetDecimal = valueAsFloat % 1 === 0 ? 0 : 2;

  const adjustedNumDecimal =
    +value < twoDecimalCutoff && !overrideCutoff ? targetDecimal : numDecimal;

  return Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    notation: 'compact',
    minimumFractionDigits: adjustedNumDecimal,
    maximumFractionDigits: adjustedNumDecimal,
    ...options,
  }).format(valueAsFloat);
};

/**
 * @deprecated
 */
export const fSimpleCurrency = (
  value: number | string,
  options: Intl.NumberFormatOptions = {}
) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    ...options,
  }).format(Number.parseFloat(value.toString()));

/**
 * @deprecated
 */
export const fSimplePercentage = (
  value: number | null | undefined,
  options: Intl.NumberFormatOptions = {}
) => {
  if (_.isNil(value)) return `${MISSING_VALUE}%`;

  return new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
    ...options,
  }).format(value);
};

/**
 * @deprecated
 */
export const fAUsers = (value: number | null) =>
  formatValue(value, ONE_DECIMAL);

type FormatOpts = Partial<{
  emptyValue: string;
}>;

/**
 * @deprecated
 */
export const fImps = (value: number | null, opts: FormatOpts = {}) =>
  formatValue(value, ONE_DECIMAL, {
    emptyValue: opts.emptyValue ?? DOUBLE_DASHES,
  });

type DateParam = ConstructorParameters<typeof Date>[0];
/**
 * @deprecated
 */
export const dateRange = (from: DateParam, to: DateParam) => {
  const fromDate = reportDate(new Date(from));
  const toDate = reportDate(new Date(to));
  return `${fromDate} to ${toDate}`;
};
